export const FIVE_AM_IN_MIN = 300;
export const ONE_THIRTY_PM_IN_MIN = 810;
export const NINE_THIRTY_PM_IN_MIN = 1290;

export const JOB_ORDER_STATUSES = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  COMPLETE: 'completed',
  OPEN: 'open',
};

export const JOB_ORDER_TIME_STATUSES = {
  UPCOMING: 'upcoming',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

export const TIMEKEEPING_STATUSES = {
  APPROVED: 'approved',
  CONFLICT: 'conflict',
  PENDING: 'pending',
  DISPUTED: 'disputed',
  RESOLVED: 'resolved',
  FINALIZED: 'finalized',
  OVERTIME: 'overtime',
};

export const STATUS_UPDATE_ACTION = {
  APPROVE: 'approve',
  RESOLVE: 'resolve',
  FINALIZE: 'finalize',
  UNFINALIZE: 'unfinalize',
};

export const SEARCH_PARAM_KEYS = {
  CORPORATION: 'corporation',
  ASSOCIATED_USER: 'associatedUser',
  FILL_RATE: 'fullShifts',
  STATUS: 'status',
  SHIFT_START: 'shiftStart',
  SHIFT_END: 'shiftEnd',
  POSITION: 'position',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
};

export const SHIFT_OPTION_KEYS = {
  FIVE_AM_TO_ONE_THIRTY_PM: 'First Shift',
  ONE_THIRTY_PM_TO_NINE_THIRTY_PM: 'Second Shift',
  NINE_THIRTY_PM_TO_FIVE_AM: 'Third Shift',
};

export const FILTERS = {
  UPCOMING: [{ field: 'end', operation: 'after', value: +new Date() }],
  COMPLETED: [{ field: 'end', operation: 'before', value: +new Date() }],
  NOT_CANCELLED: [{ field: 'cancelled', operation: 'equals', value: false }],
  LONG_TERM_JOBS: [{ field: 'shiftGroup', operation: 'notEqual', value: null }],
  DAY: [],
  get UPCOMING_JOBS() {
    return [{ field: 'end', operation: 'after', value: +new Date() }];
  },
  get COMPLETED_JOBS() {
    return [{ field: 'end', operation: 'before', value: +new Date() }];
  },
};

export const FILTER_FIELDS_TO_OPERATION = {
  corporation: { field: 'corporation', operation: 'equalsID' },
  associatedUser: { field: 'isAssociated', operation: 'equalsID' },
  fillRate: { field: 'full', operation: 'equals' },
  status: { field: 'cancelled', operation: 'equals' },
  shift: { field: 'shift', operation: 'betweenClockTimes' },
  position: { field: 'name', operation: 'icontains' },
  startDate: { field: 'start', operation: 'onOrAfter' },
  endDate: { field: 'end', operation: 'onOrBefore' },
};

const parseStringToBoolean = (value) => {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return null;
};

export const FILTER_MAPPING = {
  [SEARCH_PARAM_KEYS.CORPORATION]: {
    field: FILTER_FIELDS_TO_OPERATION.corporation.field,
    operation: FILTER_FIELDS_TO_OPERATION.corporation.operation,
  },
  [SEARCH_PARAM_KEYS.ASSOCIATED_USER]: {
    field: FILTER_FIELDS_TO_OPERATION.associatedUser.field,
    operation: FILTER_FIELDS_TO_OPERATION.associatedUser.operation,
  },
  [SEARCH_PARAM_KEYS.FILL_RATE]: {
    field: FILTER_FIELDS_TO_OPERATION.fillRate.field,
    operation: FILTER_FIELDS_TO_OPERATION.fillRate.operation,
    convertValue: (value) => parseStringToBoolean(value),
  },
  [SEARCH_PARAM_KEYS.STATUS]: {
    field: FILTER_FIELDS_TO_OPERATION.status.field,
    operation: FILTER_FIELDS_TO_OPERATION.status.operation,
    convertValue: (value) => parseStringToBoolean(value),
  },
  [SEARCH_PARAM_KEYS.POSITION]: {
    field: FILTER_FIELDS_TO_OPERATION.position.field,
    operation: FILTER_FIELDS_TO_OPERATION.position.operation,
  },
};
